import { Typography, useTheme } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "v2/components/base/Flex/ui";
import CabalTownLogo from "assets/icons/cabal-town-logo-v2.png";
import BasicButton from "v2/components/Buttons/BasicButton";
import { pageTypeMap } from "v2/routes";
import { BackButton } from "v2/components/base/Button/ui";
import { ROUTES } from "consts";
import { useRef } from "react";

// Helper to match pathname to ROUTES key, including dynamic segments
function getRouteKey(pathname: string): keyof typeof ROUTES | undefined {
  for (const key of Object.keys(ROUTES) as (keyof typeof ROUTES)[]) {
    const routePattern = ROUTES[key];
    // Replace :id or other params with a wildcard regex
    const pattern = "^" + routePattern.replace(/:[^/]+/g, "[^/]+") + "$";
    if (new RegExp(pattern).test(pathname)) {
      return key;
    }
  }
  return undefined;
}

export const Header = ({
  navigateToPorfolio,
  navigateToExplorer,
  tgUserName,
  tgPhotoUrl,
}: {
  navigateToPorfolio: () => void;
  navigateToExplorer: () => void;
  tgUserName: string;
  tgPhotoUrl: string;
}) => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const headerRef = useRef<HTMLDivElement>(null);
  const routeKey = getRouteKey(location.pathname);
  const pageType = routeKey ? pageTypeMap[ROUTES[routeKey]] : undefined;

  const navigateToPreviousRoute = () => {
    if (location.pathname.includes("token")) {
      const searchParams = new URLSearchParams(location.search);
      const isFromTokenCall = searchParams.get("from") === "cabal";
      const isFromPortfolio = searchParams.get("from") === "portfolio";

      if (isFromTokenCall) {
        const cabalId = searchParams.get("cabalId");
        searchParams.delete("from");
        searchParams.delete("cabalId");
        if (cabalId) {
          navigate(ROUTES.cabal + `/${cabalId}`);
        } else {
          navigate(ROUTES.explorer);
        }
      } else if (isFromPortfolio) {
        searchParams.delete("from");
        navigate(ROUTES.portfolio);
      } else {
        searchParams.delete("from");
        navigate(ROUTES.trade);
      }
    } else if (location.pathname.includes("airdrop")) {
      navigate(ROUTES.airdrop);
    } else {
      if (pageType?.defaultPreviousRoute) {
        navigate(pageType.defaultPreviousRoute);
      }
    }
  };

  return (
    <Col ref={headerRef} type="ss" sx={{ height: "100vh" }} fullWidth>
      <Row
        type="bc"
        sx={{
          position: "fixed",
          padding: "23px 16px",
          top: "0",
          zIndex: "1000",
          backgroundColor: "#000000",
        }}
        fullWidth>
        {pageType?.pageType === "main" ? (
          <img
            src={CabalTownLogo}
            alt="cabal-town-logo"
            onClick={navigateToExplorer}
            style={{ cursor: "pointer" }}
            height={34}
            width={139}
          />
        ) : (
          <BackButton title="Back" onClick={navigateToPreviousRoute} />
        )}
        {tgUserName ? (
          <BasicButton variant="dark" onClick={navigateToPorfolio}>
            <Typography variant="mobile-action-s-heavy">{tgUserName}</Typography>
          </BasicButton>
        ) : null}
      </Row>
      <Col
        sx={{
          maxHeight: `calc(100vh + ${headerRef.current?.offsetHeight}px)`,
          marginTop: "93px",
          overflowY: "scroll",
        }}
        fullWidth
        fullHeight>
        <Outlet />
        {/* <Row sx={{ background: `linear-gradient(to bottom,rgb(39, 245, 8),rgb(255, 8, 8))` }} fullHeight fullWidth /> */}
      </Col>
    </Col>
  );
};
